import { createFileRoute } from "@tanstack/react-router";
import { requireActive } from "../lib/require-active";

export const Route = createFileRoute("/lessons")({
  beforeLoad: ({ context }) => {
    requireActive(context);
  },
});
